import {
  primaryBase,
  secondaryBase,
  tertiaryBase,
  quaternaryBase,
  dangerBase,
} from './button';

// Mobile-specific styles
const mobileFullWidth = {
  width: '100%',
};

export const MobileButton = {
  variants: {
    // Mobile Primary Variants
    'mobile-primary': () => ({
      ...primaryBase,
      ...mobileFullWidth,
      fontSize: '1rem',
      height: '2.5rem', // 40px
      minHeight: '2.5rem',
      padding: '10px 16px',
    }),
    'mobile-primary-lg': () => ({
      ...primaryBase,
      ...mobileFullWidth,
      fontSize: '1rem',
      height: '3.125rem', // 50px
      minHeight: '3.125rem',
      padding: '14px 24px',
    }),

    // Mobile Secondary Variants
    'mobile-secondary': () => ({
      ...secondaryBase,
      ...mobileFullWidth,
      fontSize: '1rem',
      height: '2.5rem',
      minHeight: '2.5rem',
      padding: '10px 16px',
    }),
    'mobile-secondary-lg': () => ({
      ...secondaryBase,
      ...mobileFullWidth,
      fontSize: '1rem',
      height: '3.125rem',
      minHeight: '3.125rem',
      padding: '14px 24px',
    }),

    // Mobile Tertiary Variants
    'mobile-tertiary': () => ({
      ...tertiaryBase,
      ...mobileFullWidth,
      fontSize: '1rem',
      height: '2.5rem',
      minHeight: '2.5rem',
      padding: '10px 16px',
    }),
    'mobile-tertiary-lg': () => ({
      ...tertiaryBase,
      ...mobileFullWidth,
      fontSize: '1rem',
      height: '3.125rem',
      minHeight: '3.125rem',
      padding: '14px 24px',
    }),

    // Mobile Quaternary Variants
    'mobile-quaternary': () => ({
      ...quaternaryBase,
      ...mobileFullWidth,
      fontSize: '1rem',
      height: '2.5rem',
      minHeight: '2.5rem',
      padding: '10px 16px',
    }),
    'mobile-quaternary-lg': () => ({
      ...quaternaryBase,
      ...mobileFullWidth,
      fontSize: '1rem',
      height: '3.125rem',
      minHeight: '3.125rem',
      padding: '14px 24px',
    }),

    // Mobile Danger Variants
    'mobile-danger': () => ({
      ...dangerBase,
      ...mobileFullWidth,
      fontSize: '1rem',
      height: '2.5rem',
      minHeight: '2.5rem',
      padding: '10px 16px',
    }),
    'mobile-danger-lg': () => ({
      ...dangerBase,
      ...mobileFullWidth,
      fontSize: '1rem',
      height: '3.125rem',
      minHeight: '3.125rem',
      padding: '14px 24px',
    }),

    // Mobile Danger Outline Variants (for reject buttons)
    'mobile-danger-outline': () => ({
      ...mobileFullWidth,
      backgroundColor: 'transparent',
      color: 'error-200',
      border: '1px solid',
      borderColor: 'error-200',
      fontSize: '1rem',
      fontWeight: '550',
      borderRadius: 'sm',
      height: '3.125rem', // 50px
      minHeight: '3.125rem',
      padding: '14px 24px',
      _hover: {
        backgroundColor: 'error-25',
        _disabled: {
          backgroundColor: 'transparent',
          borderColor: 'secondary-500',
          color: 'secondary-500',
        },
      },
      _active: {
        backgroundColor: 'error-50',
      },
      _disabled: {
        backgroundColor: 'transparent',
        borderColor: 'secondary-500',
        color: 'secondary-500',
      },
    }),
  },
};
